import { IDepartmentList } from '@umu/umu-types';
import { getData } from '@umu/umu-util';
import { $window } from '@umu/umu-dom';
import { confirmUserRole } from '../../@utils/userRole';

export function formatDepartmentName(
    eName: string,
    departmentName: string,
    id: string,
    parentDepartment: IDepartmentList[] = [],
): string {
    const names: string[] = [eName, ...parentDepartment.map((item) => item.department_name)];

    if (departmentName && String(id) !== '0') {
        names.push(departmentName);
    }

    return names.join('/');
}

const onGetRole = () => {
    return confirmUserRole();
};

export const role = onGetRole();

export const onDisablePermissionSwitch = (oriData: any) => {
    // 先通过角色判断，如果是系统管理员，可以选择任意部门
    if (role.isAdmin) {
        return false;
    }
    // 如果是学习负责人
    if (role.isManage) {
        // 如果后台开启了 允许向企业内任意部门分配学习任务, 可以选择任意部门
        const enable_assign_task_for_any_department = getData(($window.pageData as any), 'enterprise_setting', 'enable_assign_task_for_any_department');
        if (enable_assign_task_for_any_department) {
            return false;
        }
    }
    // 其他角色根据 manage_permission 判断
    const noPermission = oriData && oriData.hasOwnProperty('manage_permission') && !oriData.manage_permission;
    return noPermission;
};
